import * as angular from "angular";
import {IController} from "angular";

export class omsPackagesInfoCtrl implements IController {

}

angular
  .module('bringoz.admin.oms')
  .component('omsPackagesInfo', {
    bindings: {
      packages: '<',
      isPacked: '<'
    },
    template: require('./oms-packages-info.html').default,
    controller: omsPackagesInfoCtrl
  });
